<script setup>
import { useRouter } from 'vue-router';
import TicketListPage from './TicketListPage.vue';

const router = useRouter();

const onCreateTicket = () => {
  router.push({ name: 'helpdesk_ticket_register' });
};
</script>

<template>
  <div class="flex flex-grow-0 w-full h-full min-h-0 app-wrapper">
    <section class="flex flex-1 h-full px-0 overflow-hidden bg-n-background">
      <TicketListPage @create-ticket="onCreateTicket" />
    </section>
  </div>
</template>
